<template>
  <div>
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="overlay" :class="[import_drawer ? 'overlay open' : 'overlay']" @click="!import_loading ? closeDrawer() : ''"></div>
    <div :class="[import_drawer ? 'pr-detail-modal open' : 'pr-detail-modal']">
      <div class="request-pr-wrap" v-if="import_drawer">
        <div class="request-pr-title" style="font-size: 16px">
          データインポート
        </div>
        <div class="request-pr-step">
          <el-steps :active="page" align-center>
            <el-step description="プラットフォーム選択" @click.native="!import_loading ? (page = 1) : ''"></el-step>
            <el-step description="ファイルアップロード" @click.native="!import_loading ? (step1 ? (page = 2) : alert()) : ''"></el-step>
            <el-step description="インポート項目の確認" @click.native="!import_loading ? (step2 ? (page = 3) : alert()) : ''"></el-step>
          </el-steps>
        </div>
        <div class="import-tips">
          <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 5px;" />
          インポートされたデータはインフルエンサー詳細ページの「ノート」タブに表示されます。
        </div>
        <div class="request-pr-form">
          <div v-show="page == 1">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                プラットフォームを選択
              </div>

              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">プラットフォーム</div>
                <div class="create-report-sns small" v-for="sns in sns_list" :key="sns.sns_type" @click="sns_type = sns.sns_type" :class="sns_type == sns.sns_type ? 'active' : ''">
                  <div class="create-report-sns-title">
                    {{ sns.sns_name }}
                    <div class="create-list-check"><font-awesome-icon :icon="['fas', 'check-circle']" v-show="sns_type == sns.sns_type" /></div>
                  </div>
                  <img class="create-report-sns-image small" :src="require('@/assets/' + sns.icon_name + '.png')" alt />
                </div>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <el-button @click="step1 ? (page += 1) : ''" type="primary" :disabled="!step1">次へ</el-button>
            </div>
          </div>
          <div v-if="page == 2">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                ファイルをアップロード
                <div class="flex-space"></div>
                <a
                  v-for="sns in sns_list"
                  :key="sns.sns_type"
                  v-show="sns.sns_type == sns_type"
                  :href="s3BaseUrl + '/templete/' + sns.template_name + '.xlsx'"
                >
                  <el-button type="info" size="small" style="margin: -7px">
                    <font-awesome-icon :icon="['far', 'arrow-to-bottom']" style="margin-right: 5px;" />
                    テンプレートファイルをダウンロード({{ sns.sns_name }}用)
                  </el-button>
                </a>
              </div>
              <div class="request-pr-form-parts" style="flex-flow: column">
                <ul class="request-pr-form-description">
                  <li>.csv .xlsx .xls形式のファイルタイプに対応しています</li>
                  <li>インポートするファイルには、下記の項目を含むヘッダー行を設定してください</li>
                  <ul class="request-pr-form-description">
                    <li v-show="sns_type == 'instagram'">Instagramユーザー名(必須)</li>
                    <li v-show="sns_type == 'youtube'">YouTubeチャンネルURL(必須)</li>
                    <li v-show="sns_type == 'tiktok'">TikTokユーザー名(必須)</li>
                    <li v-show="sns_type == 'twitter'">Xユーザー名(必須)</li>
                    <li>氏名、生年月日、住所、振込先、電話番号、メールアドレス、所属、ノート、カスタマイズタグ</li>
                    <li>ノート、カスタマイズタグは複数列の同時インポートが可能です</li>
                  </ul>
                </ul>
                <ul class="request-pr-form-description">
                  <li v-show="sns_type != 'youtube'">正確なユーザー名でない場合(全角文字や@が含まれている場合など)、データをインポートできません</li>
                  <li v-show="sns_type == 'youtube'">チャンネルURLは、[youtube.com/user/...] または [youtube.com/channel/....] の形式のみ対応しています</li>
                </ul>
                <div class="import-subwrap">
                  <el-upload
                    drag
                    accept=".csv,.xlsx,.xls"
                    :auto-upload="false"
                    :action="addFile"
                    :on-change="addFile"
                    :on-remove="deleteFile"
                    :show-file-list="false"
                    :disabled="file_uploaded"
                    :class="file_uploaded ? 'uploaded' : ''"
                  >
                    <div v-if="!file_uploaded" v-loading="file_loading" class="import-beforeupload">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">ファイルをドロップもしくは<em>選択してアップロード</em></div>
                    </div>
                    <div v-else class="import-uploaded">
                      <div class="import-uploaded-icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
                      <div class="import-uploaded-filename">{{ uploaded_info.uploaded_name }} <br />がアップロードされました</div>
                      <div class="import-uploaded-close" @click="deleteFile()">
                        <font-awesome-icon :icon="['fal', 'times']" />
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <div class="flex-space"></div>
              <el-button @click="page -= 1" type="info">戻る</el-button>
              <el-button @click="step2 ? (page += 1) : ''" type="primary" :disabled="!step2">次へ</el-button>
            </div>
          </div>
          <div v-if="page == 3">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                インポート項目を確認
                <div class="flex-space"></div>
                <div style="font-weight:400; font-size:12px">インポートする項目、インポート内容を確認し、問題なければインポートを行ってください</div>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle" style="min-width:160px">
                  インポートファイル名
                </div>
                <el-input type="text" v-model="uploaded_info.uploaded_name" disabled></el-input>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle" style="min-width:160px">
                  データ件数
                </div>
                <div style="margin-top:5px">
                  アップロード:<span class="import-num">{{ uploaded_info.uploaded_num }}</span
                  >件 / インポート可能:<span class="import-num">{{ uploaded_info.exist_num }}</span
                  >件 / {{ siteName }} 未登録
                  <el-tooltip>
                    <div slot="content">{{ siteName}} に登録されておらず、データのインポートができないアカウントの件数です。</div>
                    <font-awesome-icon :icon="['fas', 'question-circle']" />
                  </el-tooltip>
                  :<span class="import-num">{{ uploaded_info.noexist_num }}</span
                  >件
                </div>
              </div>
              <div class="divider-nomargin"></div>
              <div class="import-table-menu">
                <div class="import-table-menu-button pointer" :class="data_button == 'exist' ? 'active' : ''" @click="uploaded_info.exist_num > 0 ? (data_button = 'exist') : ''">
                  インポート可能({{ uploaded_info.exist_num }})
                </div>
                <div class="import-table-menu-button pointer" :class="data_button == 'noexist' ? 'active' : ''" @click="uploaded_info.noexist_num > 0 ? (data_button = 'noexist') : ''">
                  {{ siteName}} 未登録({{ uploaded_info.noexist_num }})
                </div>
                <div class="flex-space"></div>
                <div>上位50件までのインフルエンサーデータを表示</div>
              </div>
              <div class="import-table-wrap" id="data-table">
                <table border="0" class="import-table">
                  <thead>
                    <tr>
                      <th v-for="(header, header_index) in uploaded_data.header" :key="header" class="import-table-th" :class="header_index == sticky_index ? 'import-table-th-title' : ''">
                        <div class="import-table-th-div">
                          {{ header.property }}
                          <font-awesome-icon :icon="['fas', 'check-circle']" v-if="header.importable" style="margin-left:3px; font-size:12px; color: #27b933" />
                          <el-tooltip :disabled="header.importable" placement="top">
                            <div slot="content">有効なヘッダータイトルではないため、この列はインポートできません</div>
                            <font-awesome-icon :icon="['fas', 'exclamation-circle']" v-if="!header.importable" style="margin-left:3px; font-size:12px; color: #f56c6c" />
                          </el-tooltip>
                        </div>
                      </th>
                      <th class="import-table-th-flex"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, list_index) in data_button == 'exist' ? uploaded_data.exist : uploaded_data.noexist" :key="list_index" class="import-table-tr">
                      <td v-for="(item, item_index) in list" :key="item_index" class="import-table-td" :class="item_index == sticky_index ? 'import-table-td-title' : ''">
                        <div class="import-table-td-div">
                          <span>{{ item.value }}</span>
                        </div>
                      </td>
                      <td class="import-table-td-flex"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="request-pr-form-buttonarea">
              <el-button @click="page -= 1" type="info" :disabled="import_loading">戻る</el-button>
              <el-button @click="importFile()" type="primary" :disabled="import_loading">
                <div class="flex-row">
                  インポートする
                  <div class="loader--mini" v-show="import_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const uploadAPI = root + "/api/import/upload";
const importAPI = root + "/api/import/import";
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "importDrawer",
  props: ["import_drawer"],
  components: {
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteName: this.updateSiteName
    }
  },
  data() {
    return {
      page: 1,
      sns_type: "instagram",
      file: "",
      fileList: [],
      file_loading: false,
      file_uploaded: false,
      uploaded_data: [],
      uploaded_info: [],
      upload_error: false,
      upload_error_message: "",
      data_button: "exist",
      sticky_index: -1,
      import_loading: false,
      siteName: "REECH DATABASE",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
    search_influencer_youtube_enabled() {
      return this.$store.state.service_plan.search_influencer_youtube_enabled;
    },
    search_influencer_tiktok_enabled() {
      return this.$store.state.service_plan.search_influencer_tiktok_enabled;
    },
    search_influencer_x_enabled() {
      return this.$store.state.service_plan.search_influencer_x_enabled;
    },
    create_request_enabled() {
      return this.$store.state.service_plan.create_request_enabled;
    },
    step1() {
      if (this.sns_type != "") {
        return true;
      } else {
        return false;
      }
    },
    step2() {
      if (this.sns_type != "" && this.file_uploaded) {
        return true;
      } else {
        return false;
      }
    },
    uploadURL() {
      return uploadAPI;
    },
    sns_list() {
      let initialList = [
        { sns_name: "Instagram", sns_type: "instagram", icon_name: "ig_icon", template_name: "import_instagram" }
      ]
      if (this.search_influencer_youtube_enabled && 
          this.search_influencer_tiktok_enabled && 
          this.search_influencer_x_enabled) {
        initialList.push(
          { sns_name: "YouTube", sns_type: "youtube", icon_name: "yt_icon", template_name: "import_youtube" },
          { sns_name: "TikTok", sns_type: "tiktok", icon_name: "tt_icon", template_name: "import_tiktok" },
          { sns_name: "X", sns_type: "twitter", icon_name: "tw_icon", template_name: "import_x" }
        )
      }

      return initialList
    },
  },
  mounted() {},
  methods: {
    addFile(file, fileList) {
      this.file = "";
      this.fileList = [];
      this.file = file;
      this.fileList = fileList;
      this.file_loading = true;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      formData.append("token", this.token);
      formData.append("sns_type", this.sns_type);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.axios
        .post(uploadAPI, formData, config)
        .then((response) => {
          if (response.data.status == "OK") {
            this.uploaded_data = response.data.uploaded_data;
            this.uploaded_info = response.data.uploaded_info;
            this.sticky_index = response.data.required_index;
            if (this.uploaded_info.exist_num > 0) {
              this.data_button = "exist";
            } else {
              this.data_button = "noexist";
            }
            setTimeout(() => {
              this.upload_error = false;
              this.upload_error_message = '';
              this.file_loading = false;
              this.file_uploaded = true;
            }, 1000);
          } else {
            setTimeout(() => {
              this.file_loading = false;
              this.file_uploaded = false;
              this.showError(response.data.error_message);
            }, 1000);
          }
        })
        .catch(() => {
          this.file_loading = false;
        });
    },
    deleteFile() {
      this.file = "";
      this.fileList = [];
      this.uploaded_data = [];
      this.uploaded_info = [];
      this.upload_error = false;
      this.upload_error_message = "";
      this.data_button = "exist";
      setTimeout(() => {
        this.file_uploaded = false;
      }, 1);
    },
    importFile() {
      this.$confirm("インポートを実行すると既存のパーソナルデータは上書きされます。<br/>インポートを実行してもよろしいですか？", "データインポート", {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        confirmButtonText: "インポート",
        cancelButtonText: "キャンセル",
      }).then(() => {
        this.import_loading = true;
        var formData = new FormData();
        formData.append("file", this.file.raw);
        formData.append("sns_type", this.sns_type);
        formData.append("token", this.token);
        var config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        this.axios
          .post(importAPI, formData, config)
          .then((response) => {
            this.deleteFile();
            this.import_loading = false;
            this.page = 1;
            this.closeDrawer();
            this.$confirm(
              "インポートが完了するまで2~3分かかる場合があります。<br/>インポートの状況と履歴は、[インポート履歴]でご確認いただけます。",
              response.data.exist_num + "名のインポートを行いました",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              }
            ).then(() => {
              if (this.create_request_enabled && response.data.noexist_num > 0) {
                // 確認ダイアログ
                this.$confirm(
                  "<div>下記の" +
                    response.data.noexist_num +
                    '名のインフルエンサーは' + this.siteName + ' に未登録のためインポートできませんでした。<br>' + this.siteName + ' の登録完了後に再度インポートを実行してください。<div class="import-influencer-noexist"><div>' +
                    response.data.noexist_str +
                    "</div>",
                  response.data.noexist_num + "名のインポートができませんでした",
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "上記インフルエンサーの新規登録をリクエスト",
                    cancelButtonText: "閉じる",
                    showCancelButton: true,
                    type: "warning",
                    customClass: "import-influencer",
                  }
                ).then(() => {
                  this.$emit("openRequestDrawer", response.data.noexist_str_for_request, this.sns_type);
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "インポートに失敗しました",
            });
            this.page = 1;
            this.import_loading = false;
          });
      });
    },
    alert() {
      if (this.step1) {
        var message = "ファイルをアップロードしてください";
      } else {
        message = "プラットフォームを選択してください";
      }
      this.$message({
        type: "error",
        offset: 7,
        showClose: true,
        message: message,
      });
    },
    closeDrawer() {
      this.$emit("update:import_drawer", false);
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
    showError(message) {
      this.$message({
        type: "error",
        offset: 7,
        showClose: true,
        message: message,
      });
    },
  },
  filters: {},
  watch: {
    sns_type() {
      this.file = "";
      this.fileList = [];
      this.file_loading = false;
      this.file_uploaded = false;
      this.uploaded_data = [];
      this.uploaded_info = [];
    },
  },
};
</script>
